import React from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

interface LocationCardActionsProps {
  children: React.ReactNode;
}

const ActionsRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: 8,
  // On mobile: actions flow below the name/address, left-aligned
  justifyContent: "flex-start",
  // SM+: right-aligned in the header row
  [theme.breakpoints.up("sm")]: {
    justifyContent: "flex-end",
    flexShrink: 0,
  },
}));

/**
 * Button slot for a `LocationCard`. Accepts any React children — typically
 * MUI `Button` or legacy `.ss-button-*` buttons. Has no opinion about which
 * actions appear; callers compose this based on the location's status.
 *
 * Accessibility: renders as a `group` so screen readers announce the button
 * set as a related unit.
 */
const LocationCardActions = ({ children }: LocationCardActionsProps) => (
  <ActionsRoot role="group" aria-label="Location actions">
    {children}
  </ActionsRoot>
);

export default LocationCardActions;

